import axios from 'axios'

const functions = {
  isNewVersion (state, local) {
    if (local) {
      const copyLocal = structuredClone(local)
      const isEqual = (state.local && copyLocal && (Object.getOwnPropertyNames(state.local).length - 1) !== Object.getOwnPropertyNames(copyLocal).length)
      return isEqual
    } else if (state) {
      return false
    } else {
      return true
    }
  },
  assignJwt (commit, oldjwt, newjwt) {
    if (newjwt !== oldjwt && newjwt !== undefined && newjwt !== null) {
      axios.defaults.headers.common.Authorization = newjwt
      commit('JWT_STATE', newjwt)
    }
  },
  initDateFrom (numberOfMonths) {
  // Por defecto, numberMonths va a ser 3. Si se es superadmin, se cambiará a 1 al iniciar sesion.
    const start = new Date()
    start.setMonth(start.getMonth() - numberOfMonths)
    start.setHours(0)
    start.setMinutes(0)
    start.setSeconds(0)
    return start
  },
  initDateFromAudit (numberOfDays) {
  // Por defecto, numberMonths va a ser 3. Si se es superadmin y para auditorias, se cambiará a 3 dias al iniciar sesión.
    const start = new Date()
    start.setMonth(start.getMonth())
    start.setDate(start.getDate() - numberOfDays)
    start.setHours(0)
    start.setMinutes(0)
    start.setSeconds(0)
    return start
  },
  initDateTo () {
    const end = new Date()
    end.setHours(23)
    end.setMinutes(59)
    end.setSeconds(59)
    return end
  },
  assignLoginName (pathName) {
    console.log('pathName: ' + pathName)
    if (pathName === 'ree' || pathName === 'redelectrica') {
      return 'loginree'
    } else if (pathName === 'quiron') {
      return 'loginquiron'
    } else if (pathName === 'hipoges') {
      return 'loginhipoges'
    } else if (pathName === 'ohla' || pathName === 'Feccsp3') {
      return 'loginohl'
    } else if (pathName === 'renfe') {
      return 'loginrenfe'
    } else if (pathName === 'EECG') {
      return 'loginufgas'
    } else if (pathName === 'CanalSA') {
      return 'logincanal'
    } else if (pathName === 'lyntia') {
      return 'loginlyntia'
    } else if (pathName === 'correosexpress') {
      return 'logincorreos'
    } else if (pathName === 'telefonica') {
      return 'logintee'
    } else if (pathName === 'accionaenergia') {
      return 'loginaccionaenergia'
    } else if (pathName === 'vocento') {
      return 'loginvocento'
    } else if (pathName === 'red.es') {
      return 'loginredes'
    } else if (pathName === 'pacsa') {
      return 'loginpacsa'
    }
    
  },
  extractFilename (contentDisposition, defaultName = 'download') {
    if (!contentDisposition) return defaultName
    const parts = contentDisposition.split(';')
    const filenamePart = parts.find(p => p.trim().startsWith('filename='))
    if (!filenamePart) return defaultName
    const result = filenamePart.split('=').slice(1).join('=').trim().replaceAll('"', '')
    return result || defaultName
  }
}
export default functions
